var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.345 8.652c-.023.023-.036 0-.073.037-.355.401-.475 1.031-.475 1.779V39.65c0 .793.27 1.453.677 1.85l.135.131 16.786-16.374v-.264L9.345 8.652z",
    fill: "url(#google-play_svg__paint0_linear_1276_17640)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.81 30.803l-5.55-5.414v-.396l5.49-5.395.195.113 6.634 3.697c1.895 1.057 1.895 2.773 0 3.83l-6.769 3.565z",
    fill: "url(#google-play_svg__paint1_linear_1276_17640)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.945 30.671l-5.686-5.546L9.338 41.632c.677.66 1.624.66 2.843.132L31.945 30.67z",
    fill: "url(#google-play_svg__paint2_linear_1276_17640)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.933 19.705L12.158 8.588c-1.222-.662-2.208-.562-2.887.1l17 16.436 5.662-5.42z",
    fill: "url(#google-play_svg__paint3_linear_1276_17640)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint0_linear_1276_17640",
    x1: 24.771,
    y1: 10.217,
    x2: 2.615,
    y2: 32.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint1_linear_1276_17640",
    x1: 41.062,
    y1: 25.126,
    x2: 8.305,
    y2: 25.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint2_linear_1276_17640",
    x1: 28.868,
    y1: 28.157,
    x2: -1.175,
    y2: 58.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__paint3_linear_1276_17640",
    x1: 5.097,
    y1: -1.101,
    x2: 18.538,
    y2: 12.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgGooglePlay as ReactComponent };